// extracted by mini-css-extract-plugin
export var sliderRange = "_oj-2";
export var sliderRoot = "_oj-0";
export var sliderThumb = "_oj-3";
export var sliderTrack = "_oj-1";